// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCloud_keyword-cloud-container__ImC16 {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_loading__O\\+EMp {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_operations-tab__Cv0nw {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 10px;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_granularity-zoom-buttons__KvSPp {
  width: fit-content;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_selected-keywords-display__X0z6g {
  text-align: center;
  display: flex;
  justify-content: center;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_selected-keywords-display__X0z6g ol {
  justify-content: center;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_time-picker__o9Xt3 {
  width: 100%;
  margin-left: 10px;
}
.KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_right-section__zIe-m {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.KeywordCloud_rightclick-context-menu-keyword-cloud__UypyD {
  position: absolute;
  width: 150px;
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid lightgray;
  background-color: white;
  color: black;
}

.KeywordCloud_rightclick-context-menu-keyword-cloud__UypyD ul {
  padding: 2px;
  margin: 0;
  list-style: none;
}

.KeywordCloud_rightclick-context-menu-keyword-cloud__UypyD li {
  padding: 4px;
  font-size: 14px;
}

.KeywordCloud_rightclick-context-menu-keyword-cloud__UypyD li:hover {
  background-color: gray;
  color: white;
}

@media only screen and (max-width: 480px) {
  .KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_operations-tab__Cv0nw {
    margin: 0;
    display: grid;
    grid-template-areas: "zoom right-section" "keywords keywords";
    grid-template-columns: 1fr 1fr;
    gap: 5px;
  }
  .KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_operations-tab__Cv0nw .KeywordCloud_granularity-zoom-buttons__KvSPp {
    grid-area: zoom;
  }
  .KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_operations-tab__Cv0nw .KeywordCloud_selected-keywords-display__X0z6g {
    grid-area: keywords;
  }
  .KeywordCloud_keyword-cloud-container__ImC16 .KeywordCloud_operations-tab__Cv0nw .KeywordCloud_right-section__zIe-m {
    grid-area: right-section;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/KeywordCloud2/KeywordCloud.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,UAAA;AACJ;AAEE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAFJ;AAII;EACE,uBAAA;AAFN;AAME;EACE,WAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AALJ;;AASA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;AANF;;AASA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;AANF;;AASA;EACE,sBAAA;EACA,YAAA;AANF;;AASA;EAEI;IACE,SAAA;IACA,aAAA;IACA,6DACE;IAEF,8BAAA;IACA,QAAA;EATJ;EAUI;IACE,eAAA;EARN;EAWI;IACE,mBAAA;EATN;EAWI;IACE,wBAAA;EATN;AACF","sourcesContent":[".keyword-cloud-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  .loading {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba($color: #000000, $alpha: 0.2);\n    z-index: 1;\n  }\n\n  .operations-tab {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px;\n    border: 1px solid lightgray;\n    border-radius: 10px;\n    padding: 10px;\n  }\n\n  .granularity-zoom-buttons {\n    width: fit-content;\n  }\n\n  .selected-keywords-display {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n\n    ol {\n      justify-content: center;\n    }\n  }\n\n  .time-picker {\n    width: 100%;\n    margin-left: 10px;\n  }\n\n  .right-section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.rightclick-context-menu-keyword-cloud {\n  position: absolute;\n  width: 150px;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: 1px solid lightgray;\n  background-color: white;\n  color: black;\n}\n\n.rightclick-context-menu-keyword-cloud ul {\n  padding: 2px;\n  margin: 0;\n  list-style: none;\n}\n\n.rightclick-context-menu-keyword-cloud li {\n  padding: 4px;\n  font-size: 14px;\n}\n\n.rightclick-context-menu-keyword-cloud li:hover {\n  background-color: gray;\n  color: white;\n}\n\n@media only screen and (max-width: 480px) {\n  .keyword-cloud-container {\n    .operations-tab {\n      margin: 0;\n      display: grid;\n      grid-template-areas:\n        \"zoom right-section\"\n        \"keywords keywords\";\n      grid-template-columns: 1fr 1fr;\n      gap: 5px;\n      .granularity-zoom-buttons {\n        grid-area: zoom;\n      }\n\n      .selected-keywords-display {\n        grid-area: keywords;\n      }\n      .right-section {\n        grid-area: right-section;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyword-cloud-container": `KeywordCloud_keyword-cloud-container__ImC16`,
	"loading": `KeywordCloud_loading__O+EMp`,
	"operations-tab": `KeywordCloud_operations-tab__Cv0nw`,
	"granularity-zoom-buttons": `KeywordCloud_granularity-zoom-buttons__KvSPp`,
	"selected-keywords-display": `KeywordCloud_selected-keywords-display__X0z6g`,
	"time-picker": `KeywordCloud_time-picker__o9Xt3`,
	"right-section": `KeywordCloud_right-section__zIe-m`,
	"rightclick-context-menu-keyword-cloud": `KeywordCloud_rightclick-context-menu-keyword-cloud__UypyD`
};
export default ___CSS_LOADER_EXPORT___;
